import React from 'react';
import { CurrencyAmount, CurrencyType, FormatCurrencyValue } from '../../../../utils/currency';
import GACurrencyInput, { GACurrencyInputOnChangeValues } from '../../../inputs/GACurrencyInput';

/**
 * Displays a donation request panel that provides a currency input and a button to make a donation request.
 */

/**
 * Props for Donation Panel
 * name: ID Name for panel and Currency Input
 * donationMinimum: The minimum amount of currency, in the input currency, permissible to input
 * currency: Currency Type to accept
 * onDonationClick: Callback function triggered when the user inputs a donation amount and clicks 'Donate'
 */
interface donationPanelProps {
    name: string,
    donationMinimum: number,
    currency: CurrencyType
    onDonationClick: (arg0: donationPanelValue) => void
}

/**
 * Interface for return value from donation Panel
 * name: Name of panel (used to differentiate between multiple inputs)
 * value: Submitted currency value
 */
export interface donationPanelValue {
    name: string,
    value: CurrencyAmount
}

/**
 * Main Component
 * TBD: Accepting multiple currencies besides USD. 
 */
const DonationPanel = (props: donationPanelProps) => 
{
    
    const [amountValid, setAmountValid] = React.useState<boolean>(false);
    const [amount, setAmount] = React.useState<FormatCurrencyValue>({});
    const [displayError, setDisplayError] = React.useState<boolean>(false);

    // TBD: Will become a set of currencies provided as a prop.
    const localization = props.currency.localization;

    
    // Performs validation and saving of donation amount.
    const validateAmount = (values?: GACurrencyInputOnChangeValues) => 
    {
        if(values?.float != null)
        {
            setAmount(values);

            if (values?.float && values.float >= props.donationMinimum)
            {
                setAmountValid(true);
            }
            else
            {
                setAmountValid(false);
            }
        }
        else
        {
            setAmount({});
            setAmountValid(false);
        }
    }

    const checkErrorDisplay = (values: GACurrencyInputOnChangeValues) =>  
    {
        setAmount(values);
        setDisplayError((values?.float == null || values?.float == 0) ? false : !amountValid);
    }




    const mimimumDonationElement = <p className='donationPanelValidationMinimum'>minimum: {localization.format(props.donationMinimum)}</p>;



 
    return(
        <div className='donationPanel simple-border'>


            <b className='donationPanelTitle'>Make a Donation</b>

            <GACurrencyInput
                className='donationPanelInput'
                name={props.name}
                currency={props.currency}
                min={0}
                max={9999.99}
                onValueChange={validateAmount}
                onInputBlur={checkErrorDisplay}
            />

            <div className='donationPanelValidation'>

                {(displayError) ?
                    <div>
                        {mimimumDonationElement}
                        <p className='donationPanelTextError'>Donation below minimum</p>
                        <p className='donationPanelTextError'>transaction amount</p>
                    </div>
                :
                    <div>
                        {mimimumDonationElement}
                    </div>
                }

            </div>


            <button className='buttonPrimary donationPanelButton'
                disabled={!amountValid}
                onClick={() => amount && props.onDonationClick({ name: props.name, value: {currency: props.currency, value: amount }})}
            >
                Donate
            </button>


        </div>
    );
}

export default DonationPanel;